import { render } from "./DataPreferenceSettings.vue?vue&type=template&id=0ab5a8e6&scoped=true&ts=true"
import script from "./DataPreferenceSettings.vue?vue&type=script&lang=ts"
export * from "./DataPreferenceSettings.vue?vue&type=script&lang=ts"

import "./DataPreferenceSettings.vue?vue&type=style&index=0&id=0ab5a8e6&lang=scss&scoped=true"

import exportComponent from "C:\\TeamCityBuildAgent\\work\\623dcfb411009e26\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ab5a8e6"]])

export default __exports__